import { CustomerApproval } from "models/Order";
import PageLayout from "../components/PageLayout";
import InspectionsSection from "../components/InspectionsSection";
import PageContent from "../components/PageContent";

type InspectionsPageProps = {
  inspections: CustomerApproval[];
};

const InspectionsPage: React.FC<InspectionsPageProps> = ({ inspections }) => {
  return (
    <PageLayout>
      <PageContent>
        <InspectionsSection inspections={inspections} />
      </PageContent>
    </PageLayout>
  );
};

export default InspectionsPage;
